import { render, staticRenderFns } from "./template.vue?vue&type=template&id=01f8af62&scoped=true&"
import script from "@/Components/Global/Spinner/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/Spinner/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/Spinner/style.scss?vue&type=style&index=0&id=01f8af62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f8af62",
  null
  
)

export default component.exports